import { FunctionComponent, ReactElement, useEffect } from "react";
import "./SuccessfulLogin.scss";

export const SuccessfulLogin: FunctionComponent = (): ReactElement => {
  useEffect(() => {
    window.close();
  });
  return (
    <div className={"successful-login"}>
      <p className={"successful-login_text"}>Successfully Logged in!</p>
    </div>
  );
};
